import React, { useState } from 'react';

interface PaymentMethod {
  type: 'visa' | 'mastercard' | 'amex';
  last4: string;
  expiry: string;
}

const PlanInfo: React.FC = () => {
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>({
    type: 'visa',
    last4: '8543',
    expiry: '12/26'
  });
  const [cardNumber, setCardNumber] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [cvv, setCvv] = useState('');
  const [showReceiptsExpanded, setShowReceiptsExpanded] = useState(false);

  const handleUpdatePayment = () => {
    if (cardNumber && expiryDate && cvv) {
      const last4 = cardNumber.slice(-4);
      setPaymentMethod({
        type: 'visa',
        last4,
        expiry: expiryDate
      });
      setShowPaymentForm(false);
      setCardNumber('');
      setExpiryDate('');
      setCvv('');
    }
  };

  return (
    <div style={{ padding: '32px', maxWidth: '1200px' }}>
      {/* Page Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 700, color: '#FFFFFF', margin: '0 0 8px 0' }}>
          Plan info
        </h1>
        <p style={{ fontSize: '14px', color: '#87CEEB', margin: 0 }}>
          Current plan, add-ons, receipts
        </p>
      </div>

      {/* Upcoming Bill */}
      <div style={{
        backgroundColor: '#113F67',
        border: '1px solid #6CA6C1',
        borderRadius: '8px',
        padding: '24px',
        marginBottom: '24px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#FFFFFF', margin: '0 0 8px 0' }}>
              Upcoming bill
            </h3>
            <p style={{ fontSize: '14px', color: '#87CEEB', margin: '0 0 4px 0' }}>
              Next bill date: November 7, 2025
            </p>
            <p style={{ fontSize: '14px', color: '#87CEEB', margin: 0 }}>
              Total: $99.00 + applicable taxes
            </p>
          </div>
          <button style={{
            padding: '10px 20px',
            backgroundColor: 'transparent',
            color: '#87CEEB',
            border: '1px solid #6CA6C1',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 600
          }}>
            View upcoming bill
          </button>
        </div>
      </div>

      {/* Plan and Add-on Details */}
      <div style={{
        backgroundColor: '#113F67',
        border: '1px solid #6CA6C1',
        borderRadius: '8px',
        padding: '24px',
        marginBottom: '24px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#FFFFFF', margin: 0 }}>
            Plan and add-on details
          </h3>
          <button style={{
            padding: '10px 20px',
            backgroundColor: 'transparent',
            color: '#87CEEB',
            border: '1px solid #6CA6C1',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 600
          }}>
            Change plan
          </button>
        </div>

        {/* Plan Card */}
        <div style={{
          borderLeft: '3px solid #6CA6C1',
          paddingLeft: '16px',
          marginBottom: '24px'
        }}>
          <div style={{ marginBottom: '16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <h4 style={{ fontSize: '18px', fontWeight: 600, color: '#F7E9A0', margin: 0 }}>
                Plus
              </h4>
              <span style={{ fontSize: '16px', fontWeight: 600, color: '#FFFFFF' }}>
                $99/mo
              </span>
            </div>
            <p style={{ fontSize: '14px', color: '#87CEEB', margin: '0 0 16px 0' }}>
              For the practice looking to simplify admin work and streamline their business
            </p>
          </div>

          {/* Plan Details Section */}
          <div style={{ marginBottom: '16px' }}>
            <h5 style={{ fontSize: '12px', fontWeight: 700, color: '#F7E9A0', letterSpacing: '0.05em', margin: '0 0 12px 0' }}>
              ▼ PLAN DETAILS
            </h5>
            <div style={{ marginLeft: '16px' }}>
              <p style={{ fontSize: '14px', color: '#FFFFFF', margin: '0 0 16px 0' }}>
                Plus plan <span style={{ float: 'right' }}>$99/month</span>
              </p>

              <div style={{ marginTop: '16px' }}>
                <p style={{ fontSize: '14px', fontWeight: 600, color: '#FFFFFF', margin: '0 0 8px 0' }}>
                  Team Members
                </p>
                <p style={{ fontSize: '13px', color: '#87CEEB', margin: '0 0 4px 0', marginLeft: '16px' }}>
                  Additional clinicians <span style={{ float: 'right' }}>Starting at $74/month</span>
                </p>
                <p style={{ fontSize: '13px', color: '#87CEEB', margin: '0 0 4px 0', marginLeft: '16px' }}>
                  Practice managers <span style={{ float: 'right' }}>$39/month</span>
                </p>
                <p style={{ fontSize: '13px', color: '#87CEEB', margin: '0', marginLeft: '16px' }}>
                  Admin users <span style={{ float: 'right' }}>Free</span>
                </p>
              </div>

              <div style={{ marginTop: '16px' }}>
                <p style={{ fontSize: '14px', fontWeight: 600, color: '#FFFFFF', margin: '0 0 8px 0' }}>
                  Insurance
                </p>
                <p style={{ fontSize: '13px', color: '#87CEEB', margin: '0 0 4px 0', marginLeft: '16px' }}>
                  Claims <span style={{ float: 'right' }}>first 35 free/month, then starts at $0.25 per claim</span>
                </p>
                <p style={{ fontSize: '13px', color: '#87CEEB', margin: '0', marginLeft: '16px' }}>
                  Manual insurance status checks <span style={{ float: 'right' }}>Free</span>
                </p>
              </div>
            </div>
          </div>

          {/* Add-ons Section */}
          <div>
            <h5 style={{ fontSize: '12px', fontWeight: 700, color: '#F7E9A0', letterSpacing: '0.05em', margin: '0 0 12px 0' }}>
              ▼ ADD-ONS
            </h5>
            <div style={{ marginLeft: '16px' }}>
              <div style={{ marginBottom: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <p style={{ fontSize: '14px', fontWeight: 600, color: '#FFFFFF', margin: 0 }}>
                    Note Taker <span style={{
                      fontSize: '11px',
                      fontWeight: 400,
                      color: '#87CEEB',
                      backgroundColor: '#0A2540',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      marginLeft: '8px'
                    }}>30-day trial available</span>
                  </p>
                  <button style={{
                    padding: '6px 16px',
                    backgroundColor: 'transparent',
                    color: '#87CEEB',
                    border: '1px solid #6CA6C1',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}>
                    Manage access
                  </button>
                </div>
                <p style={{ fontSize: '13px', color: '#87CEEB', margin: '0 0 4px 0' }}>
                  Simplify progress note writing with an AI-powered digital scribe
                </p>
                <p style={{ fontSize: '13px', color: '#87CEEB', margin: 0 }}>
                  $35/month per clinician
                </p>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <p style={{ fontSize: '14px', fontWeight: 600, color: '#FFFFFF', margin: 0 }}>
                    Medication Management
                  </p>
                  <span style={{
                    padding: '6px 12px',
                    backgroundColor: '#28527A',
                    color: '#87CEEB',
                    borderRadius: '4px',
                    fontSize: '12px'
                  }}>
                    Included
                  </span>
                </div>
                <p style={{ fontSize: '13px', color: '#87CEEB', margin: '0 0 4px 0' }}>
                  Record medications, track medication history, and manage refill reminders
                </p>
                {/* Electronic prescribing is not built. Advertising it as a paid
                    add-on sold a capability the app does not have. */}
                <p style={{ fontSize: '12px', color: '#D4A017', margin: 0 }}>
                  Does not transmit prescriptions electronically — electronic prescribing
                  (Surescripts/DrFirst) is planned, not available today.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Method */}
      <div style={{
        backgroundColor: '#113F67',
        border: '1px solid #6CA6C1',
        borderRadius: '8px',
        padding: '24px',
        marginBottom: '24px'
      }}>
        <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#FFFFFF', margin: '0 0 16px 0' }}>
          Payment method
        </h3>

        {!showPaymentForm ? (
          <div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px',
              backgroundColor: '#0A2540',
              borderRadius: '6px',
              marginBottom: '16px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '40px',
                  height: '28px',
                  backgroundColor: '#1A5490',
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#FFFFFF',
                  fontSize: '10px',
                  fontWeight: 700
                }}>
                  VISA
                </div>
                <div>
                  <p style={{ fontSize: '14px', fontWeight: 600, color: '#FFFFFF', margin: '0 0 4px 0' }}>
                    Visa ending in {paymentMethod.last4}
                  </p>
                  <p style={{ fontSize: '13px', color: '#87CEEB', margin: 0 }}>
                    Expires {paymentMethod.expiry}
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowPaymentForm(true)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: 'transparent',
                  color: '#87CEEB',
                  border: '1px solid #6CA6C1',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '13px'
                }}
              >
                Update
              </button>
            </div>
          </div>
        ) : (
          <div style={{
            padding: '16px',
            backgroundColor: '#0A2540',
            borderRadius: '6px',
            marginBottom: '16px'
          }}>
            <h4 style={{ fontSize: '14px', fontWeight: 600, color: '#FFFFFF', margin: '0 0 16px 0' }}>
              Update payment method
            </h4>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#FFFFFF', marginBottom: '8px' }}>
                Card Number
              </label>
              <input
                type="text"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value.replace(/\D/g, '').slice(0, 16))}
                placeholder="1234 5678 9012 3456"
                style={{
                  width: '100%',
                  padding: '10px',
                  backgroundColor: '#113F67',
                  border: '1px solid #6CA6C1',
                  borderRadius: '4px',
                  color: '#FFFFFF',
                  fontSize: '14px'
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#FFFFFF', marginBottom: '8px' }}>
                  Expiry Date (MM/YY)
                </label>
                <input
                  type="text"
                  value={expiryDate}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, '');
                    if (value.length >= 2) {
                      value = value.slice(0, 2) + '/' + value.slice(2, 4);
                    }
                    setExpiryDate(value);
                  }}
                  placeholder="MM/YY"
                  maxLength={5}
                  style={{
                    width: '100%',
                    padding: '10px',
                    backgroundColor: '#113F67',
                    border: '1px solid #6CA6C1',
                    borderRadius: '4px',
                    color: '#FFFFFF',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#FFFFFF', marginBottom: '8px' }}>
                  CVV
                </label>
                <input
                  type="text"
                  value={cvv}
                  onChange={(e) => setCvv(e.target.value.replace(/\D/g, '').slice(0, 3))}
                  placeholder="123"
                  maxLength={3}
                  style={{
                    width: '100%',
                    padding: '10px',
                    backgroundColor: '#113F67',
                    border: '1px solid #6CA6C1',
                    borderRadius: '4px',
                    color: '#FFFFFF',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowPaymentForm(false)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: 'transparent',
                  color: '#87CEEB',
                  border: '1px solid #6CA6C1',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '13px'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleUpdatePayment}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#226F9E',
                  color: '#FFFFFF',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: 600
                }}
              >
                Update
              </button>
            </div>
          </div>
        )}
      </div>

      {/* MyClinicCore Receipts */}
      <div style={{
        backgroundColor: '#113F67',
        border: '1px solid #6CA6C1',
        borderRadius: '8px',
        padding: '24px',
        marginBottom: '24px'
      }}>
        <button
          onClick={() => setShowReceiptsExpanded(!showReceiptsExpanded)}
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: 0
          }}
        >
          <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#FFFFFF', margin: 0 }}>
            {showReceiptsExpanded ? '▼' : '▶'} MyClinicCore receipts
          </h3>
        </button>

        {showReceiptsExpanded && (
          <div style={{ marginTop: '16px' }}>
            <p style={{ fontSize: '14px', color: '#87CEEB', margin: '0 0 16px 0' }}>
              Each time you are billed by MyClinicCore, a receipt will be sent to your email
            </p>
          </div>
        )}
      </div>

      {/* Cancel Account */}
      <div>
        <button style={{
          padding: '10px 20px',
          backgroundColor: 'transparent',
          color: '#FF6B6B',
          border: '1px solid #FF6B6B',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '14px'
        }}>
          Cancel account
        </button>
      </div>
    </div>
  );
};

export default PlanInfo;
